import { Empty, List, Skeleton, Spin } from "antd";
import React from "react";

export const LoadingCircleImage = ({ data, width, height }) => {
  return (
    <div>
      {!data ? (
        <Skeleton.Avatar
          active
          shape="circle"
          style={{ width: `${width}px`, height: `${height}px` }}
        />
      ) : (
        <img src={data} alt="image" />
      )}
    </div>
  );
};

export const LoadingParagraph = ({ data, component }) => {
  return (
    <div>{!data ? <Skeleton.Input active size="small" /> : component}</div>
  );
};

export const LoadingSpin = ({ data, component, style, size }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {data.length > 0 ? component : <Spin size={size ? size : "small"} />}
    </div>
  );
};

export const LoadingList = ({
  data,
  component,
  rows,
  avatar,
  recordNum = 4,
}) => {
  const listSkeleton = Array.from({
    length: recordNum,
  }).map((_, i) => {
    return (
      <Skeleton
        key={i}
        style={{ marginBottom: "30px" }}
        avatar={avatar}
        paragraph={{
          rows: rows,
        }}
        active
      />
    );
  });
  return (
    <div>{data ? data.length > 0 ? component : <Empty /> : listSkeleton}</div>
  );
};

export const LoadingCard = ({ rows, imageUrl, avatar }) => {
  return (
    <div
      style={{
        marginBottom: "30px",
        backgroundImage: `url(${imageUrl})`,
        padding: "15px 10px",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
      }}
    >
      <Skeleton
        avatar={avatar}
        paragraph={{
          rows: rows,
        }}
        active
      />
    </div>
  );
};
export const LoadingListEntity = ({
  isLoading,
  grid,
  backgroundImage,
  component,
  componentNum,
  rows = 2,
  avatar = true,
}) => {
  return isLoading ? (
    <List
      grid={grid}
      dataSource={Array.from({ length: componentNum }, (_, i) => i + 1)}
      renderItem={(index) => {
        return (
          <List.Item key={index}>
            <LoadingCard
              rows={rows}
              imageUrl={backgroundImage}
              avatar={avatar}
            />
          </List.Item>
        );
      }}
    />
  ) : (
    component
  );
};
export const LoadingSpinKeyword = ({ isLoading, component, style, size }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {!isLoading ? component : <Spin size={size ? size : "small"} />}
    </div>
  );
};
